export default __webpack_public_path__ + "static/media/afterProfile.10c76bab.jpg";